import { render, staticRenderFns } from "./CheckBox.vue?vue&type=template&id=4d9cc019&scoped=true&lang=pug&"
import script from "./CheckBox.vue?vue&type=script&lang=ts&"
export * from "./CheckBox.vue?vue&type=script&lang=ts&"
import style0 from "./CheckBox.vue?vue&type=style&index=0&id=4d9cc019&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9cc019",
  null
  
)

export default component.exports